/**
 * TanStack Router: /performance/clima
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceClimaPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceClimaPage from '@/app/performance/clima/page'

/**
 * Route: /performance/clima
 * Layout: _auth (authenticated)
 * Component: PerformanceClimaPage
 */
export const Route = createFileRoute('/_auth/performance/clima')({
  component: PerformanceClimaPage,
})
